var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4999 4.16669C30.9071 4.16669 24.4625 6.12165 18.9808 9.78437C13.4992 13.4471 9.22679 18.653 6.70387 24.7439C4.18095 30.8348 3.52084 37.537 4.80701 44.003C6.09318 50.4691 9.26788 56.4085 13.9296 61.0703C18.5914 65.732 24.5308 68.9067 30.9968 70.1929C37.4629 71.479 44.1651 70.8189 50.256 68.296C56.3468 65.7731 61.5528 61.5007 65.2155 56.019C68.8782 50.5374 70.8332 44.0927 70.8332 37.5C70.8332 28.6595 67.3213 20.181 61.0701 13.9298C54.8189 7.67858 46.3404 4.16669 37.4999 4.16669ZM8.33319 37.5C8.42414 30.0069 11.3957 22.8362 16.6316 17.4751C21.8675 12.1141 28.9659 8.97396 36.4548 8.70602C43.9438 8.43808 51.2485 11.0629 56.8541 16.0361C62.4597 21.0092 65.9361 27.9492 66.5624 35.4167H36.4374L17.2915 58.4792C14.4653 55.7636 12.2155 52.5063 10.6763 48.9017C9.1371 45.2972 8.3402 41.4194 8.33319 37.5ZM37.4999 66.6667C31.393 66.6636 25.4433 64.7314 20.4999 61.1459L38.3957 39.5834H66.5624C66.036 46.9343 62.7463 53.8134 57.3548 58.8377C51.9633 63.8621 44.8696 66.6592 37.4999 66.6667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieGraph);
export default __webpack_public_path__ + "static/media/PieGraph.ee902a0b.svg";
export { ForwardRef as ReactComponent };